import { service } from 'services';
import { basicCRUDAction, dispatchPendingAction, hotGetAction } from 'utils';
import dataCenter from 'services/data-center';
import { ACTIONS_TYPES } from '../helper';

export default {
  get: async ({ dcId, id, isPassiveLoading }) => hotGetAction({
    action: ACTIONS_TYPES.SERVER.GET,
    apiResult: service.server.get({ dcId, id }),
    isPassiveLoading,
  }),

  create: async ({ dcId, server }) => basicCRUDAction({
    action: ACTIONS_TYPES.DATA_CENTER.CREATE_SERVER,
    apiResult: service.server.create({ dcId, server }),
  }),

  update: async ({ dcId, id, properties }) => basicCRUDAction({
    action: ACTIONS_TYPES.SERVER.UPDATE,
    apiResult: service.server.update({ dcId, id, properties }),
  }),

  action: async ({ action, dcId, id }) => basicCRUDAction({
    action: ACTIONS_TYPES.SERVER.ACTION,
    apiResult: service.server.action({ action, dcId, id }),
  }),

  delete: async ({ dcId, id }) => basicCRUDAction({
    action: ACTIONS_TYPES.SERVER.DELETE,
    apiResult: service.server.delete({ dcId, id }),
  }),

  attachCdRom: async ({ id, cdRomId, dcId }) => basicCRUDAction({
    action: ACTIONS_TYPES.SERVER.ATTACH_CD_ROM,
    apiResult: service.server.attachCdRom({ id, cdRomId, dcId }),
  }),

  getCdRom: async ({ cdromId, dcId, id }) => hotGetAction({
    action: ACTIONS_TYPES.STORAGE.GET,
    apiResult: service.server.getCdRom({ cdromId, dcId, id }),
  }),

  deattachCdRom: async ({ id, cdRomId, dcId }) => basicCRUDAction({
    action: ACTIONS_TYPES.SERVER.DEATTACH_CD_ROM,
    apiResult: service.server.deattachCdRom({ id, cdRomId, dcId }),
  }),

  attachVolume: async ({ id, dcId, volumeId }) => basicCRUDAction({
    action: ACTIONS_TYPES.SERVER.ATTACH_VOLUME,
    apiResult: service.server.attachVolume({ id, dcId, volumeId }),
  }),

  getVolume: async ({ dcId, id, volumeId }) => hotGetAction({
    action: ACTIONS_TYPES.STORAGE.GET,
    apiResult: service.server.getVolume({ dcId, id, volumeId }),
  }),

  deattachVolume: async ({ id, dcId, volumeId }) => basicCRUDAction({
    action: ACTIONS_TYPES.SERVER.DEATTACH_VOLUME,
    apiResult: service.server.deattachVolume({ id, dcId, volumeId }),
  }),

  getOverallServers: async (isPassiveLoading = false) => {
    if (!isPassiveLoading) {
      dispatchPendingAction({ action: ACTIONS_TYPES.SERVER.GET_OVERALL_SERVERS });
    }

    let result = [];
    const { items: dataCenters = [] } = await dataCenter.getAll({});
    const dcsPromises = dataCenters.map(({ id }) => dataCenter.get({ id }));
    const dcsResponse = await Promise.all(dcsPromises);

    for (const dc of dcsResponse) {
      const { id, properties = {}, entities = {} } = dc;
      const { servers: serversObj = {} } = entities;
      let { items: servers = [] } = serversObj;
      servers = servers.map((e) => ({ ...e, dataCenter: { id, properties } }));

      result = [...result, ...servers];
    }

    hotGetAction({
      action: ACTIONS_TYPES.SERVER.GET_OVERALL_SERVERS,
      apiResult: (async () => result)(),
      payloadKey: ACTIONS_TYPES.SERVER.GET_OVERALL_SERVERS,
      isPassiveLoading,
    });
  },
};
